import { render, staticRenderFns } from "./DeleteParcel.vue?vue&type=template&id=1861fcc4&"
import script from "./DeleteParcel.vue?vue&type=script&lang=js&"
export * from "./DeleteParcel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports